export const normalizeKeyboardSettings = (settings = {}) => {
  const requested = settings.autoCorrectionLevel
  const autoCorrectionLevel = Number.isInteger(requested) && requested >= 1 && requested <= 5
    ? requested
    : 3
  return {
    ...settings,
    autoCorrectionLevel,
    autoCorrection: settings.autoCorrection !== false
  }
}

export const effectiveAutocorrectionLevel = settings => {
  const normalized = normalizeKeyboardSettings(settings)
  return normalized.autoCorrection ? normalized.autoCorrectionLevel : 1
}

export const autocorrectionPreferences = [
  { label: 'Suggest only', description: 'Show corrections for you to choose. Never apply them automatically.' },
  { label: 'Prefer suggestions', description: 'Leave more words as typed. Correct automatically only when the intent is especially clear.' },
  { label: 'Balanced', description: 'Correct when the intent is clear; otherwise suggest. The default.' },
  { label: 'Prefer corrections', description: 'Apply more likely corrections, accepting a little more uncertainty.' },
  { label: 'Correct', description: 'Favor correcting likely typos, even when the choice is less certain.' }
]
